
const awsconfig = {
    SesEmailAPI: 'https://6o2nq3rkhj.execute-api.us-east-1.amazonaws.com/stage/sendemail'
}

export default awsconfig;